import { Stack, Text, PrimaryButton } from "@certn/cascadia";
import { Trans, useTranslation } from "react-i18next";
import { css } from "@emotion/css";
import { BrandingUploadSection } from "./BrandingUploadSection";
import { useBrandingContext } from "../BrandingContext";

export function BrandingUpload() {
  const { t } = useTranslation();
  const { isSaving, isLoading, isDirty, saveBrandAssetsFromValues } =
    useBrandingContext();
  const isSavingOrLoading = isSaving || isLoading;
  const isApplyDisabled = isSavingOrLoading || !isDirty;

  return (
    <Stack gap="space-6" className={styles.flexOne}>
      <Stack gap="space-5">
        <Text style="global/body-secondary">
          {t(
            "Add your company logo so applicants see your brand in invites and communications, building trust at every step."
          )}
        </Text>
        <BrandingUploadSection />
        <PrimaryButton
          onPress={() => saveBrandAssetsFromValues()}
          isLoading={isSavingOrLoading}
          isDisabled={isApplyDisabled}
        >
          <Trans>Apply changes</Trans>
        </PrimaryButton>
      </Stack>
    </Stack>
  );
}

const styles = {
  flexOne: css({
    flex: 1,
    width: "100%",
  }),
};
